import { UiTable, UiSelect, UiRangePicker, UiProfileModel } from "../../../../components";
import { DatePicker } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { formatAmount, tablePageSizeOptions } from "../../../../utils/appUtils";
import { LAWYERMANAGEMENT, CUSTOMERMANAGEMENT } from "../../../../apiServices/endpoints";
import { TRANSACTION_HISTORY_STATUS_OPTIONS } from "../config";
import './style.scss';
const TransactionHistory = ({ 
    user, 
    activeTabKey, 
    onBack, 
    filter, 
    setFilter, 
    resultData, 
    transactionList, 
    totalElements, 
    handlePagination,
    columns,
    categoryOptions
}) => {

    return (
        <div className="transaction-history">
            <div className="flexible">
            <div className="transaction-header">
                 <ArrowLeftOutlined onClick={onBack} className="back-icon" />
                <h6>Transaction History</h6>
            </div>
               <div className="filters-section">
                <div>
                    <DatePicker 
                        picker="month" 
                        format="MMM"
                        placeholder="Select Month" 
                        value={filter?.month}
                        onChange={(date) => setFilter(prev => ({ ...prev, month: date, startDate: null, endDate: null, page: 0 }))}
                        disabledDate={(current) => current && current > dayjs().endOf("day")}
                        style={{ height: 32, width: 150, borderRadius: 6 }}
                    />
                </div>
                <div>
                    <UiRangePicker 
                        placeholder={["Start date", "End date"]}
                        value={filter?.startDate && filter?.endDate ? [dayjs(filter?.startDate), dayjs(filter?.endDate)] : null}
                        onChange={(dates) => setFilter(prev => ({ ...prev, startDate: dates?.[0] || null, endDate: dates?.[1] || null, month: null, page: 0 }))}
                        disabledDate={(current) => current && current > dayjs().endOf("day")}
                        style={{ width: '250px' }}
                    />
                </div>
                <div>
                    <UiSelect 
                        placeholder="Category"
                        value={filter?.category}
                        onChange={(value) => setFilter(prev => ({ ...prev, category: value, page: 0 }))}
                        options={categoryOptions}
                        allowClear={true}
                        style={{ width : '150px'}}
                    />
                </div>
                <div>
                    <UiSelect 
                        placeholder="Status" 
                        value={filter?.status}
                        onChange={(value) => setFilter(prev => ({ ...prev, status: value, page: 0 }))}
                        options={TRANSACTION_HISTORY_STATUS_OPTIONS} 
                        allowClear={true}
                        style={{ width : '120px'}}
                    />
                </div>
            </div>
            </div>
            <div className="profile-section">
                <div className="profile-container">
                    <div className="profile-avatar">
                        {activeTabKey === "1" && resultData?.profileUrl ? (
                            <UiProfileModel imageUrl={`${LAWYERMANAGEMENT}/file${resultData?.profileUrl}`} />
                        ) : activeTabKey === "2" && resultData?.profileUrl ? (
                            <UiProfileModel imageUrl={`${CUSTOMERMANAGEMENT}/file${resultData?.profileUrl}`} />
                        ) : (
                            <span>{user?.lawyerName?.[0] || user?.customerName?.[0]}</span>
                        )}
                    </div>
                    <div className="profile-info">
                        <h5>{resultData?.lawyerName || resultData?.customerName || user?.lawyerName || user?.customerName}</h5>
                        <p>ID: {user?.lawyerNo || user?.customerNo}</p>
                    </div>
                </div>
                <div className="stats-container">
                    {activeTabKey === "2" && (
                        <>
                            <div className="stat-item">
                                <p>Total Cons. Amount</p>
                                <p>₹ {formatAmount(resultData?.totalConsultationAmount)}</p>
                            </div>
                             <div className="stat-item">
                                <p>Total Recharge Amount</p>
                                <p>₹ {formatAmount(resultData?.totalRechargeAmount)}</p>
                            </div>
                            <div className="stat-item">
                                <p>Total Refunded Amount</p>
                                <p>₹ {formatAmount(resultData?.totalRefundedAmount)}</p>
                            </div>
                             <div className="stat-item">
                                <p>Paid From My Balance</p>
                                <p>₹ {formatAmount(resultData?.totalAmountPayFromMyBalance)}</p>
                            </div>
                        </>
                    )}
                    {activeTabKey === "1" && (
                         <>
                            <div className="stat-item">
                                <p>Total Paid Amount</p>
                                <p>₹ {formatAmount(resultData?.totalFees)}</p>
                            </div>
                             <div className="stat-item">
                                <p>Unpaid Amount</p>
                                <p>₹ {formatAmount(resultData?.totalUnpaidAmount)}</p>
                            </div>
                            <div className="stat-item">
                                <p>Penalty Amount</p>
                                <p>₹ {formatAmount(resultData?.totalPenaltyAmount)}</p>
                            </div>
                         </>
                    )}
                </div>
            </div>
            <UiTable
                columns={columns}
                dataSource={transactionList}
                scroll={{ x: "max-content", y: "calc(100vh - 320px)" }}
                pagination={{
                    current: filter?.page + 1,
                    pageSize: filter?.size,
                    total: totalElements,
                    pageSizeOptions: tablePageSizeOptions,
                    showSizeChanger: true,
                    onChange: handlePagination
                }}
            />
        </div>
    );
};

export default TransactionHistory;
